module.exports = __webpack_public_path__ + "static/media/48270511_2308807069194471_2510349977251741696_o-thumb.f5eb0fba.jpg";